var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._v(_vm._s(_vm.getterVariationPrice))]),_vm._v(" "),_c('span',{staticClass:"is-size-4"},[_vm._v(_vm._s(_vm.getterVariationCurrency))])])}
var staticRenderFns = []

export { render, staticRenderFns }